import React from 'react'
import styled from 'styled-components'

function Mothafar() {
    return (
        <Container>
            <h1>من هو محمد المظفر ؟</h1>
            <Wrap>
            <img src="/images/who2.png" alt="المحامي محمد المظفر" />
            <p>
            محمد عبدالله المظفر مواليد 24/5/1992 كويتي متزوج، محامي تخرج من جامعة عجمان للعلوم و التكنولوجيا تخصص قانون في دولة الإمارات العربية المتحدة، تقدم بأوراق تقيده في جمعية المحامين الكويتية سنة 2018 و تم تقيده كمحامي في 11/7/2019، اشتهر المظفر بحبه للفكاهة و نشر الابتسامة بين الناس عبر حسابه في مواقع التواصل الاجتماعي و بسبب هذا الامر الذي ساهم في نجاحه كمحامي، في 3/9/2020 قامت جمعية المحامين الكويتية و بطريقة غير قانونية بشطب قيده معلله ذلك بأنه يمس المهنة بتصرفاته على وسائل التواصل الاجتماعي ما دعاه الى تقديم شكوى في المحاكم الكويتية كون ان ما يقوم به من افعال لا تمس المهنة و الاجراء الذي تم اتخاذه من جمعية المحامين غير قانوني وفي 27/9/2021 حكمت المحكمة لصالح محمد المظفر و ألزمت جمعية المحامين الكويتية بإعادة قيده كمحامي، لكن الامر لم ينتهي عند هذا الحد رفضت جمعية المحامين تنفيذ الحكم وقامت بتقديم اشكال لتكسب بعض الوقت و تماطل في تنفيذ الحكم الصادر بإسم صاحب السمو امير دولة الكويت انذاك، رفضت المحكمة الإشكال المقدم من جمعية المحامين الكويتية ما دعى المظفر الى تقديم طلب منع سفر ضد رئيس جمعية المحامين كونه الشخص المسؤول عن تنفيذ الاحكام الصادره ضد الجمعية و وافقت المحكمة على طلبه ما جعلهم يقومون بتنفيذ الحكم في 15/11/2021  و اعادة قيده كمحامي في جمعية المحامين الكويتية ليعود المحامي الكوميدي و بقوة القانون، وقد اصدر المظفر في 5/11/2021 كتاب يحكي قصته تحت عنوان “ محامي كوميدي “ و شارك الكتاب في معرض الكتاب المقام في الشارقة و كان من الكتب الأعلى مبيعاً و حالياً متواجد الكتاب في جميع مكتبات الخليج العربي.
            </p>
            </Wrap>
        </Container>
    )
}

export default Mothafar


const Container = styled.div`



h1 {
    font-size : 20px;
}

`

const Wrap = styled.div`
    display: flex;
    border-radius: 10px;
    text-align: justify;
    cursor: pointer;
    overflow: hidden;
    border: 3px solid rgba(249, 249, 249, 0.1);
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
    
    
    img{
        width: 400px;
        height: 350px;
        object-fit: cover;
    }
    &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
        transform: scale(1.05);
        border-color: rgba(249, 249, 249, 0.8);
    }

    p{
        margin: 20px;
        line-height: 1.5;
       

    }

    @media only screen and (min-width: 480px) and (max-width: 768px) {
        flex-direction: column;
        text-align: justify;
        margin-top: 25px;
        margin-bottom: 35px;

        
        img {
            width: 100%
        }

        p{
            line-height: 1.66;
        }
       
        
        
     
      }

      @media only screen and (max-width: 479px) {
        flex-direction: column;
       
        text-align: justify;
        margin-top: 25px;
        margin-bottom: 35px;

        img {
            width: 100%
        }

        p{
            line-height: 1.66;
        }
        
      }

`